import React, { createContext, useContext, useState } from 'react';
const OrderContext = createContext();

export const useOrder = () => {
    return useContext(OrderContext);
};

// OrderProvider to provide the context value
export const OrderProvider = ({ children }) => {
    const [orderCompleted, setOrderCompleted] = useState(false);

    const completeOrder = () => {
        setOrderCompleted(true);
    };

    const resetOrder = () => {
        setOrderCompleted(false);
    };

    return (
        <OrderContext.Provider value={{ orderCompleted, completeOrder, resetOrder }}>
            {children}
        </OrderContext.Provider>
    );
};
